(() => {
  if (window.__cartAddErrorInterceptor) return;
  window.__cartAddErrorInterceptor = true;

  const CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  const THEME_HEADER = 'x-requested-with';

  function isCartAdd(url) {
    if (!url) return false;
    try {
      return CART_ADD.test(String(url));
    } catch (e) {
      return false;
    }
  }

  function resolveMessage(parsed) {
    if (typeof parsed.description === 'string' && parsed.description.trim()) {
      return parsed.description;
    }

    const raw = parsed.errors;
    if (typeof raw === 'string' && raw.trim()) return raw;
    if (raw && typeof raw === 'object') {
      const parts = Object.values(raw).flat().filter(Boolean);
      if (parts.length) return parts.join(' ');
    }

    return parsed.message || '';
  }

  function showInline(message) {
    if (!message) return true;

    const quickView = document.querySelector('quick-add-modal[open]');
    const form = quickView
      ? quickView.querySelector('product-form')
      : document.querySelector('product-info[id^="MainProduct-"] product-form');
    if (!form) return false;

    const wrapper = form.querySelector('.product-form__error-message-wrapper');
    const target = wrapper && wrapper.querySelector('.product-form__error-message');
    if (!wrapper || !target) return false;

    target.textContent = message;
    wrapper.removeAttribute('hidden');
    return true;
  }

  function showPopup(message, attempt) {
    if (!message) return;

    const tries = attempt || 0;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartError, { source: 'cart-add-interceptor', message: message });
      return;
    }
    if (tries >= 40) return;
    setTimeout(() => showPopup(message, tries + 1), 50);
  }

  function report(body) {
    let parsed = body;

    if (typeof parsed === 'string') {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        parsed = { description: body };
      }
    }

    if (!parsed || typeof parsed !== 'object') return;

    const message = resolveMessage(parsed);
    if (!showInline(message)) showPopup(message);
  }

  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSend = XMLHttpRequest.prototype.send;
  const nativeSetHeader = XMLHttpRequest.prototype.setRequestHeader;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartAddWatch = String(method || '').toUpperCase() === 'POST' && isCartAdd(url);
    return nativeOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.setRequestHeader = function (name) {
    if (String(name || '').toLowerCase() === THEME_HEADER) this.__themeRequest = true;
    return nativeSetHeader.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__cartAddWatch && !this.__themeRequest) {
      this.addEventListener('load', () => {
        if (this.status >= 400) report(this.responseText);
      });
    }
    return nativeSend.apply(this, arguments);
  };

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      const method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      const headers = new Headers((init && init.headers) || (input && input.headers) || {});
      const isTheme = headers.has(THEME_HEADER);
      const watch = method === 'POST' && isCartAdd(url) && !isTheme;

      const result = nativeFetch.apply(this, arguments);
      if (!watch) return result;

      return result.then((response) => {
        if (!response.ok) response.clone().text().then(report).catch(() => {});
        return response;
      });
    };
  }
})();
